// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FsesController from "./fses_controller"
application.register("fses", FsesController)

import ProductSelectionController from "./product_selection_controller"
application.register("product-selection", ProductSelectionController)

import SystemsOnboardingController from "./systems_onboarding_controller"
application.register("systems-onboarding", SystemsOnboardingController)
